<script setup lang="ts">
import ogImage from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/pages/partner/400f/ogimage.png/ogimage.webp';
import Partner400FTemplate from '~/components/templates/_lp/Partner400FTemplate/Partner400FTemplate.vue';

useAppMeta({
  noindex: true,
  imagePath: ogImage,
});
definePageMeta({
  layout: 'plain',
});
</script>

<template>
  <Partner400FTemplate />
</template>
